
/* Product ID to single Variant ID mapping */
let tangent_selected_product_map = {};

let default_addToCartText = "Legg i handlekurv";
const default_addedToCartText = "Lagt til i handlekurven!";
const default_add_all_to_cart_text = "Legg alle i handlekurven";
const out_of_stock_text = "Utsolgt";
const no_products_found_text = "Ingen produkter funnet. Prøv på nytt!";

let tangent_client_domain_currency;
let sections_add_to_cart_map = {};
let klaviyoRendered = false;

const tabs_title_mapping = {
    section_am: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="1em" height="1em" role="img"><path fill="#1D1D1D" fill-rule="evenodd" d="M8 5.334a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0M8 0c.368 0 .667.299.667.667V2a.667.667 0 0 1-1.334 0V.667C7.333.299 7.632 0 8 0M8 13.334c.368 0 .667.298.667.667v1.333a.667.667 0 0 1-1.334 0V14c0-.369.299-.667.667-.667" clip-rule="evenodd"></path></svg> AM Routine',
    section_pm: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="1em" height="1em" role="img"><path fill="#1D1D1D" fill-rule="evenodd" d="M7.041.685a.67.67 0 0 1-.044.724 4 4 0 0 0 5.594 5.594.667.667 0 0 1 1.06.598A6.666 6.666 0 1 1 6.4.349a.67.67 0 0 1 .642.336M5.198 1.972a5.333 5.333 0 1 0 6.83 6.83 5.333 5.333 0 0 1-6.83-6.83" clip-rule="evenodd"></path></svg> PM Routine'
};

const productDependentSections = [
    "section_basic_am_cleanser",
    "section_basic_am_toner",
    "section_basic_am_serum",
    "section_basic_am_moisturizer",
    "section_basic_am_eye",
    "section_basic_am_spf",
    "section_basic_cleanser",
    "section_basic_pm_toner",
    "section_basic_pm_serum",
    "section_basic_pm_moisturizer",
    "section_basic_pm_eye",
    "section_basic_pm_spf",
    "section_advanced_precleanse",
    "section_advanced_cleanser",
    "section_advanced_peeling",
    "section_advanced_toner",
    "section_advanced_regenerate",
    "section_advanced_eye",
    "section_advanced_serum",
    "section_advanced_spf",
    "section_advanced_night_cream"
];

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");

const tangent_default_selfie_image_url =
    "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/5363869866003381-7%20(1).jpg";

const default_variant_image_url =
    "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp";

const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper");

/* Initialize the recommendation request without overwriting other onload handlers. */
window.addEventListener("load", function () {
    const responseId = getClientResponseId();

    if (!responseId) {
        hideLoadingSection();
        console.error("Tangent recommendation: resp_id is missing from the URL.");
        return;
    }

    checkoutDataApiCall(responseId);
});

function getClientResponseId() {
    const clientUrl = new URL(window.location.href);
    return clientUrl.searchParams.get("resp_id");
}

function checkoutDataApiCall(responseId) {
    if (!responseId) return;

    const checkoutUrl =
        "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" +
        encodeURIComponent(responseId) +
        "&self_serve=true&multiple_variants=true";

    fetch(checkoutUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error("Tangent API request failed: " + response.status);
            }
            return response.json();
        })
        .then(response => {
            checkoutDataProcess(response);
        })
        .catch(error => {
            hideLoadingSection();
            console.error("Tangent checkout error:", error);
        });
}

function checkoutDataProcess(response) {
    hideLoadingSection();

    response = response || {};

    const tangent_recommended_products =
        Array.isArray(response.products) ? response.products : [];

    const currencyElement = document.querySelector("#tangent_client_currency");

    tangent_client_domain_currency = currencyElement
        ? currencyElement.innerText.trim()
        : "$";

    if (!tangent_client_domain_currency) {
        tangent_client_domain_currency = "$";
    }

    setTangentSelfieSection(response);

    const tangent_product_sections = response.product_sections || {};
    const tangent_text_sections = response.text_sections || {};

    /* Reset generated state before rendering. */
    sections_add_to_cart_map = {};
    tangent_selected_product_map = {};

    if (tangent_custom_tabs) {
        tangent_custom_tabs.innerHTML = "";
    }

    createTabButton("section_am");
    createTabButton("section_pm");

    createProductSection(tangent_product_sections, tangent_text_sections);

    createTextSection(tangent_product_sections, tangent_text_sections);

    setTabOpen(response.tags);

    if (
        tangent_recommended_products.length > 0 &&
        Object.keys(tangent_product_sections).length > 0
    ) {
        setProductsToView(
            tangent_recommended_products,
            tangent_product_sections,
            response.selected_variants || {}
        );

        initTangentAddToCartButtons();
        showElementsAfterDataLoad();
        addCustomAddAllToCarts();

        /* Set the initial selected routine on every Add All button. */
        syncAddAllButtons("section_am");
    } else {
        const generalText = document.querySelector("#tangent-general-text");

        if (generalText) {
            generalText.textContent = no_products_found_text;
        }

        console.warn("Tangent returned no products or no product sections.");
    }
}

/* =========================================================
   ADD ALL TO CART BUTTONS
   ========================================================= */

function addCustomAddAllToCarts() {
    const amContainer = document.getElementById("section_am_container");
    const pmContainer = document.getElementById("section_pm_container");

    if (
        amContainer &&
        !amContainer.querySelector("#tangent-add-all-to-cart-section_am")
    ) {
        amContainer.appendChild(appendAddAllToCart("section_am"));
    }

    if (
        pmContainer &&
        !pmContainer.querySelector("#tangent-add-all-to-cart-section_pm")
    ) {
        pmContainer.appendChild(appendAddAllToCart("section_pm"));
    }
}

function appendAddAllToCart(section) {
    const buttonContainer = document.createElement("div");
    buttonContainer.className = "custom-add-all-to-cart-container";

    const addAllButton = document.createElement("button");

    /* Unique IDs prevent AM, PM and mobile buttons from colliding. */
    addAllButton.id = `tangent-add-all-to-cart-${section}`;
    addAllButton.className =
        "tangent-add-all-to-cart-button product-buy-buttons--cta btn custom-add-all-to-cart";

    addAllButton.type = "button";
    addAllButton.textContent = "LEGG ALT I HANDLEKURVEN";
    addAllButton.name = section;
    addAllButton.dataset.sectionName = section;

    addAllButton.addEventListener("click", function () {
        addAllTocartFunction(addAllButton);
    });

    buttonContainer.appendChild(addAllButton);

    return buttonContainer;
}

/* Keep desktop and mobile buttons synchronized with the active tab. */
function syncAddAllButtons(sectionName) {
    if (sectionName !== "section_am" && sectionName !== "section_pm") {
        return;
    }

    // Update only the desktop button for the selected routine.
    const selectedButton = document.getElementById(
        `tangent-add-all-to-cart-${sectionName}`
    );

    if (selectedButton) {
        selectedButton.name = sectionName;
        selectedButton.dataset.sectionName = sectionName;
    }

    document.querySelectorAll(
        ".tangent-add-all-to-cart-button, " +
        ".tangent-add-all-to-cart-button-mobile"
    ).forEach(button => {
        button.name = sectionName;
        button.dataset.sectionName = sectionName;
    });
}

/* =========================================================
   PRODUCT RENDERING
   ========================================================= */

function setProductsToView(products, sections, selected_variants) {
    tangent_selected_product_map = {};

    Object.keys(sections || {}).forEach(section => {
        const productIds = Array.isArray(sections[section])
            ? sections[section]
            : [];

        const productGrid = document.getElementById(
            section + "_product_grid"
        );

        if (!productGrid) {
            console.warn("Product grid not found for section:", section);
            return;
        }

        /* Avoid duplicating products if rendering runs more than once. */
        productGrid.innerHTML = "";

        const fragment = document.createDocumentFragment();
        let availableProductCount = 0;

        for (const id of productIds) {
            for (let p = 0; p < products.length; p++) {
                const product = products[p];

                if (!product || String(product.id) !== String(id)) {
                    continue;
                }

                const selectedVariants =
                    selected_variants && selected_variants[product.id];

                const variant = getSelectedVariant(product, selectedVariants);

                if (!variant || !isProductAvailable(product, variant)) {
                    continue;
                }

                availableProductCount++;

                tangent_selected_product_map[product.id] = variant.id;

                const productHtml = getProductHTML(
                    product,
                    p,
                    variant,
                    section,
                    sections
                );

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = productHtml;

                while (tempDiv.firstChild) {
                    fragment.appendChild(tempDiv.firstChild);
                }
            }
        }

        productGrid.appendChild(fragment);

        if (availableProductCount === 0) {
            const sectionWrapper = document.getElementById(
                section + "_container"
            );

            if (sectionWrapper) {
                sectionWrapper.remove();
            }
        }
    });
}

function getSelectedVariant(product, variantList) {
    const productVariants =
        product && Array.isArray(product.variants)
            ? product.variants
            : [];

    if (productVariants.length === 0) {
        console.warn(
            "Skipping product without variants:",
            product && product.title,
            product && product.id
        );
        return null;
    }

    const selectedVariantIds = Array.isArray(variantList)
        ? variantList
        : variantList == null
            ? []
            : [variantList];

    if (selectedVariantIds.length > 0) {
        const selectedVariantId = Number(selectedVariantIds[0]);

        return (
            productVariants.find(
                variant => Number(variant.id) === selectedVariantId
            ) || productVariants[0]
        );
    }

    return productVariants[0];
}

/* =========================================================
   TABS
   ========================================================= */

function createTabButton(sectionName) {
    if (!tangent_custom_tabs) {
        console.warn("Tangent tabs container was not found.");
        return;
    }

    const tabButton = document.createElement("button");

    tabButton.id = sectionName + "_tab_button";
    tabButton.innerHTML = getTabTitle(sectionName);
    tabButton.name = sectionName;
    tabButton.type = "button";
    tabButton.classList.add("tablinks");

    tabButton.addEventListener("click", function () {
        switchTab(this);
    });

    tangent_custom_tabs.appendChild(tabButton);
}

function getTabTitle(section) {
    if (tabs_title_mapping[section] !== undefined) {
        return tabs_title_mapping[section];
    }

    return section
        .replace("section_", "")
        .replace("_", " ")
        .toUpperCase();
}

function switchTab(element) {
    if (!element || !element.name) return;

    document.querySelectorAll(".tabcontent").forEach(tab => {
        tab.style.display = "none";
    });

    document.querySelectorAll(".tablinks").forEach(tab => {
        tab.classList.remove("active");
    });

    const selectedContainer = document.getElementById(
        element.name + "_container"
    );

    if (selectedContainer) {
        selectedContainer.style.display = "flex";
    }

    element.classList.add("active");

    /* Critical mobile fix: update ALL buttons, not just getElementById(). */
    syncAddAllButtons(element.name);
}

function setTabOpen(tags) {
    const tabWrapper = document.querySelector("#tab-wrapper");
    const tabContents = document.querySelectorAll(".tabcontent");
    const tabLinks = document.querySelectorAll(".tablinks");

    if (tabWrapper) {
        tabWrapper.style.display = "block";
    }

    if (tabContents.length > 0) {
        tabContents.forEach(tab => {
            tab.style.display = "none";
        });

        const initialContainer = document.getElementById("section_am_container");

        if (initialContainer) {
            initialContainer.style.display = "flex";
        } else {
            tabContents[0].style.display = "block";
        }
    }

    if (tabLinks.length > 0) {
        tabLinks.forEach(link => link.classList.remove("active"));

        const amTab = document.getElementById("section_am_tab_button");

        if (amTab) {
            amTab.classList.add("active");
        } else {
            tabLinks[0].classList.add("active");
        }
    }

    syncAddAllButtons("section_am");
}

/* =========================================================
   PRODUCT CARD HTML
   ========================================================= */

function getProductHTML(product, index, variant, section, sections) {
    const variantImageUrl = getVariantImage(variant.image_id, product);

    const variantProductUrl =
        `${tangent_client_domain_url}/products/${product.handle}?variant=${variant.id}`;

    let variantTitle = "(" + (variant.title || "") + ")";

    if (variant.title === "Default Title") {
        variantTitle = "";
    }

    let buttonClass = "";
    let buttonText = default_addToCartText;

    if (isProductAvailable(product, variant)) {
        updateSectionAllToCartLink(section, product.id);
    } else {
        buttonText = out_of_stock_text;
        buttonClass = "disable-button";
    }

    return `
        <div>
            <a id="url_tangent_product_${index}"
               class="tangent-text-link"
               target="_blank"
               href="${variantProductUrl}">
                <img id="image_tangent_product_${index}"
                     src="${variantImageUrl}"
                     class="tangent_product_image"
                     alt="${product.title || ""}">

                <p class="tangent-product-title tangent_product_title_text">
                    ${product.title || ""}<br>${variantTitle}
                </p>

                <p>${product.product_type || ""}</p>

                <span class="klaviyo-star-rating-widget"
                      data-id="${product.id}"
                      data-product-title="${product.title || ""}"
                      data-product-type="${product.product_type || ""}"
                      style="display: block;"></span>

                <p id="price_tangent_product_${index}"
                   class="tangent_product_price_text">
                    ${tangent_client_domain_currency}${variant.price}
                </p>
            </a>

            <button type="button"
                    class="tangent-product-add-btn-wrapper tangent_add_to_cart_button product-buy-buttons--cta btn ${buttonClass}"
                    data-section-name="${section}"
                    id="${variant.id}"
                    ${buttonClass ? "disabled" : ""}>
                <span>${buttonText}</span>
            </button>
        </div>
    `;
}

function isProductAvailable(product, variant) {
    if (!product || product.status !== "active" || !variant) {
        return false;
    }

    return variant.available_for_sale === true;
}

/* =========================================================
   AM/PM CART MAP
   ========================================================= */

function updateSectionAllToCartLink(section, productId) {
    /* Determine AM/PM using the actual section name. */
    const addAllKey = section.includes("_am_")
        ? "section_am"
        : "section_pm";

    const variantId = tangent_selected_product_map[productId];

    if (variantId === undefined || variantId === null) {
        return;
    }

    if (!sections_add_to_cart_map[addAllKey]) {
        sections_add_to_cart_map[addAllKey] = {
            count: 0,
            cart_link: `${tangent_client_domain_url}/cart/add?`,
            list: []
        };
    }

    const sectionData = sections_add_to_cart_map[addAllKey];

    if (!sectionData.list.includes(variantId)) {
        sectionData.count++;
        sectionData.list.push(variantId);

        const separator = sectionData.cart_link.includes("?") ? "&" : "?";

        sectionData.cart_link +=
            `${separator}id[]=${encodeURIComponent(variantId)}`;
    }
}

const getVariantImage = (imageId, product) => {
    const fallbackImage = default_variant_image_url;

    if (imageId && Array.isArray(product.images)) {
        const foundImage = product.images.find(
            image => String(image.id) === String(imageId)
        );

        if (foundImage && foundImage.src) {
            return foundImage.src;
        }
    }

    if (product.image && product.image.src) {
        return product.image.src;
    }

    if (Array.isArray(product.images) && product.images.length > 0) {
        const firstImage = product.images[0];

        if (firstImage && firstImage.src) {
            return firstImage.src;
        }
    }

    return fallbackImage;
};

/* =========================================================
   CART PAYLOAD
   ========================================================= */

function createFormDataFromIds(element, idArray) {
    const sectionName =
        (element && element.dataset && element.dataset.sectionName) ||
        (element && element.name) ||
        "section_am";

    const isAmRoutine = sectionName.includes("am");

    let buttonType = isAmRoutine ? "am-routine" : "pm-routine";

    const isAddAllButton =
        element &&
        element.classList &&
        (
            element.classList.contains("tangent-add-all-to-cart-button") ||
            element.classList.contains("tangent-add-all-to-cart-button-mobile") ||
            element.classList.contains("custom-add-all-to-cart")
        );

    if (isAddAllButton) {
        buttonType = "tangent-add-all-to-cart-" + buttonType;
    }

    const uniqueIds = [
        ...new Set(
            (Array.isArray(idArray) ? idArray : []).filter(
                id => id !== undefined && id !== null && id !== ""
            )
        )
    ];

    const items = uniqueIds.map(id => ({
        id: id,
        quantity: 1,
        properties: {
            _type: buttonType,
            _variantIds: uniqueIds
        }
    }));

    return { items: items };
}

function addToCart(element) {
    if (!element || !element.id) {
        console.error("Add to Cart: product variant ID is missing.");
        return;
    }

    const formData = createFormDataFromIds(element, [element.id]);

    addToCartApi(formData, element);
}

/* =========================================================
   ADD ALL TO CART
   ========================================================= */

function addAllTocartFunction(element) {
    const sectionName =
        (element && element.dataset && element.dataset.sectionName) ||
        (element && element.name);

    const sectionData = sectionName
        ? sections_add_to_cart_map[sectionName]
        : null;

    if (!sectionData || !Array.isArray(sectionData.list)) {
        console.error("Add All to Cart: section not found in cart map.", {
            sectionName: sectionName || "(empty)",
            availableSections: Object.keys(sections_add_to_cart_map),
            button: element
        });

        return;
    }

    if (sectionData.list.length === 0) {
        console.warn(
            "Add All to Cart: no available products for",
            sectionName
        );

        const message = document.querySelector("#message-text");

        if (message) {
            message.textContent =
                "We're currently sold out of the selected product(s). Please check back later!";

            message.classList.add("show");

            setTimeout(() => {
                message.classList.remove("show");
            }, 5000);
        }

        return;
    }

    const formData = createFormDataFromIds(element, sectionData.list);

    if (!formData.items.length) {
        console.warn("Add All to Cart: cart payload is empty.");
        return;
    }

    addToCartApi(formData, element);
}

/* =========================================================
   SHOPIFY CART API
   ========================================================= */

function addToCartApi(payload, element) {
    if (
        !payload ||
        !Array.isArray(payload.items) ||
        payload.items.length === 0
    ) {
        console.warn("Add to Cart cancelled: no valid items.");
        return;
    }

    if (!element) {
        console.error("Add to Cart: button element is missing.");
        return;
    }

    if (element.disabled) {
        return;
    }

    const originalText =
        element.dataset.originalText || element.textContent.trim();

    element.dataset.originalText = originalText;
    element.disabled = true;
    element.innerHTML = '<div class="loader button-loader">&nbsp;</div>';

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(payload)
    })
        .then(async response => {
            if (!response.ok) {
                const errorDetails = await response.text();

                throw new Error(
                    `Cart request failed (${response.status}): ${errorDetails}`
                );
            }

            return response.json();
        })
        .then(() => {
            element.textContent = default_addedToCartText;
            element.classList.add("added-to-cart-style");

            document.dispatchEvent(
                new CustomEvent("dispatch:cart-drawer:refresh")
            );

            document.dispatchEvent(
                new CustomEvent("dispatch:cart-drawer:open")
            );
        })
        .catch(error => {
            console.error("Add to Cart failed:", error);
            element.textContent = originalText;
        })
        .finally(() => {
            element.disabled = false;
        });
}

/* =========================================================
   SECTION CREATION
   ========================================================= */

function createSectionWrapper(sectionName) {
    const sectionWrapper = document.createElement("div");
    sectionWrapper.id = `${sectionName}_container`;

    return sectionWrapper;
}

function createSectionProductGrid(sectionName) {
    const productGridContainer = document.createElement("div");

    productGridContainer.id = `${sectionName}_product_grid`;

    productGridContainer.classList.add(
        "section_product_grid",
        `${sectionName}_product_grid`
    );

    return productGridContainer;
}

function createProductSection(productSections, textSections) {
    const basicAmGrid = document.getElementById(
        "tangent-basic-am-product-grid"
    );

    const basicPmGrid = document.getElementById(
        "tangent-basic-pm-product-grid"
    );

    for (const [sectionName] of Object.entries(productSections || {})) {
        const sectionWrapper = createSectionWrapper(sectionName);

        if (textSections) {
            createTextSectionBeforeProducts(
                textSections,
                sectionWrapper,
                sectionName
            );
        }

        sectionWrapper.appendChild(
            createSectionProductGrid(sectionName)
        );

        let targetGrid;

        const isBasic = sectionName.includes("basic");
        const isAm = sectionName.includes("_am_");
        const isPm = sectionName.includes("_pm_");

        if (isBasic && isAm) {
            targetGrid = basicAmGrid;
        } else if (isBasic && isPm) {
            targetGrid = basicPmGrid;
        }

        if (targetGrid) {
            targetGrid.appendChild(sectionWrapper);
        } else {
            console.warn(
                "Product section has no matching target grid:",
                sectionName
            );
        }
    }
}

/* =========================================================
   TEXT SECTIONS
   ========================================================= */

function createTextSectionBeforeProducts(
    textSections,
    sectionContainer,
    sectionName
) {
    if (!textSections || !textSections[sectionName]) {
        return;
    }

    const sectionDiv = document.createElement("div");

    sectionDiv.id = `${sectionName}_text_container`;

    sectionDiv.classList.add(
        "section_text_container",
        `${sectionName}_text_container`
    );

    sectionDiv.innerHTML = Array.isArray(textSections[sectionName])
        ? textSections[sectionName].join(" ")
        : textSections[sectionName];

    sectionContainer.appendChild(sectionDiv);
}

function createTextSection(productSections, textSections) {
    if (!textSections) return;

    for (const sectionName in textSections) {
        if (
            productSections &&
            productSections[sectionName] !== undefined
        ) {
            continue;
        }

        if (productDependentSections.includes(sectionName)) {
            continue;
        }

        if (
            document.getElementById(`${sectionName}_container`)
        ) {
            continue;
        }

        const sectionContainer = createSectionWrapper(sectionName);
        const sectionDiv = document.createElement("div");

        sectionDiv.id = `${sectionName}_text_container`;

        sectionDiv.classList.add(
            "section_text_container",
            `${sectionName}_text_container`
        );

        sectionDiv.innerHTML = Array.isArray(textSections[sectionName])
            ? textSections[sectionName].join(" ")
            : textSections[sectionName];

        sectionContainer.appendChild(sectionDiv);

        if (sectionName === "section_selfie") {
            const selfieSection = document.querySelector(
                "#section_selfie_container_parent"
            );

            if (selfieSection) {
                selfieSection.appendChild(sectionContainer);
            }
        } else if (tangent_sections_wrapper_element) {
            tangent_sections_wrapper_element.appendChild(sectionContainer);
        }
    }
}

/* =========================================================
   SELFIE AND PERSONALIZED TEXT
   ========================================================= */

function setTangentSelfieSection(response) {
    hideLoadingSection();

    appendPersonalizedTextWithRetake(response.tags || []);

    const selfieContainer = document.getElementById(
        "tangent_selfie_container"
    );

    const imageContainer = document.getElementById(
        "tangent_selfie_image_container"
    );

    const selfieImage = document.getElementById(
        "tangent_selfie_image"
    );

    if (response.selfie_html) {
        if (imageContainer) {
            imageContainer.innerHTML = response.selfie_html;
        }

        return;
    }

    if (response.selfie_url && selfieImage) {
        selfieImage.src = response.selfie_url;
        return;
    }

    if (tangent_default_selfie_image_url && selfieImage) {
        selfieImage.src = tangent_default_selfie_image_url;
        return;
    }

    if (selfieContainer) {
        selfieContainer.style.display = "none";
    }
}

function appendPersonalizedTextWithRetake(tags) {
    const container = document.getElementById(
        "section_selfie_container_parent"
    );

    if (!container) return;

    if (container.querySelector(".selfie-personalized-title")) {
        return;
    }

    const titleEl = document.createElement("h2");

    titleEl.className = "selfie-personalized-title";
    titleEl.textContent = "Her er din personlige hudpleierutine:";

    container.appendChild(titleEl);

    const text = buildPersonalizedProductText(tags);

    if (text) {
        const textEl = document.createElement("p");

        textEl.className = "selfie-personalized-text";
        textEl.innerHTML = text;

        container.appendChild(textEl);
    }

    const linkEl = document.createElement("a");

    linkEl.className = "selfie-retake-quiz";
    linkEl.href = "/pages/skin-quiz";
    linkEl.textContent = "Ta quizen på nytt";
    linkEl.style.display = "inline-block";
    linkEl.style.textDecoration = "underline";

    container.appendChild(linkEl);

    const addAllButton = document.createElement("button");

    /* Mobile button must not reuse the desktop button ID. */
    addAllButton.id = "tangent-add-all-to-cart-mobile";

    addAllButton.className =
        "tangent-add-all-to-cart-button-mobile product-buy-buttons--cta btn";

    addAllButton.type = "button";
    addAllButton.textContent = "Legg denne rutinen i handlekurven";

    addAllButton.name = "section_am";
    addAllButton.dataset.sectionName = "section_am";

    addAllButton.addEventListener("click", function () {
        addAllTocartFunction(addAllButton);
    });

    container.appendChild(addAllButton);
}

/* =========================================================
   PERSONALIZED TEXT HELPERS
   ========================================================= */

function extractUserAttributesFromTags(tags) {
    const data = {
        age: null,
        skinType: null,
        concern: null
    };

    if (!Array.isArray(tags)) {
        return data;
    }

    tags.forEach(tag => {
        if (typeof tag !== "string") return;

        if (tag.startsWith("age_")) {
            data.age = tag
                .replace("age_", "")
                .replace("_", "–");
        }

        if (tag.startsWith("skin_type_")) {
            data.skinType = tag
                .replace("skin_type_", "")
                .replace(/_/g, " ");
        }

        if (tag.startsWith("skin_condition_")) {
            data.concern = tag
                .replace("skin_condition_", "")
                .replace(/_/g, " ");
        }
    });

    return data;
}

function buildPersonalizedProductText(tags) {
    const { age, skinType, concern } =
        extractUserAttributesFromTags(tags);

    let text = "Disse produktene er personlig tilpasset for deg";

    const parts = [];

    if (age) {
        parts.push(`du er <strong>${age}</strong> år gammel`);
    }

    if (skinType) {
        parts.push(`har <strong>${skinType}</strong> hudtype`);
    }

    if (concern) {
        parts.push(`er bekymret for <strong>${concern}</strong>`);
    }

    if (parts.length) {
        text += ", fordi du fortalte oss at " + parts.join(", ");
    }

    return text + ".";
}

/* =========================================================
   PRODUCT BUTTON INITIALIZATION
   ========================================================= */

function initTangentAddToCartButtons() {
    const addToCartButtons = document.querySelectorAll(
        ".tangent-product-add-btn-wrapper"
    );

    addToCartButtons.forEach(button => {
        if (button.dataset.listenerAttached === "true") {
            return;
        }

        button.dataset.listenerAttached = "true";

        button.addEventListener("click", function () {
            addToCart(button);
        });
    });
}

/* =========================================================
   LOADER HELPERS
   ========================================================= */

function showElementsAfterDataLoad() {
    const deferredElements = document.querySelectorAll(".load-on-data");

    deferredElements.forEach(element => {
        element.style.display = "flex";
    });
}

function hideLoadingSection() {
    const loadingSection = document.getElementById("loading-section");

    if (loadingSection) {
        loadingSection.style.display = "none";
    }
}
